import React, { useState } from "react";
import SectionLayout from "./SectionLayout";

const SectionFormLayout = ({ sectionData, onChangeSection }) => {
  const [sections, setSections] = useState(sectionData);

  const handleChangeSection = (updatedSection) => {
    setSections((prevSections) => {
      const newSections = [...prevSections]; // clone array
      newSections[0] = {
        ...newSections[0], // keep old props
        ...updatedSection // merge new props
      };
      return newSections;
    });

    if (typeof onChangeSection === "function") {
      onChangeSection(updatedSection);
    }
  };

  return (
    <div className="main_formrenderer_section" style={{ height: "calc(100% - 136px)" }}>
      <SectionLayout sectionData={sections[0]} onChangeSection={handleChangeSection} />
    </div>
  );
};

export default SectionFormLayout;
